import { Component } from '@angular/core';

import { ModalController, NavParams, PopoverController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';

import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeIdDto, EmployeeV2Dto, EmployerDto, ExaBeaconRestService, ExaBeaconV2Dto } from 'src/app/api/exa';
import { EmployeeService } from 'src/app/services/employee.service';
import { EmployeeStateEnum } from 'src/app/enums/employee-state-enum';
import { BeaconTypeEnum } from 'src/app/enums/beacon-type-enum';
import { NameFormattingService } from 'src/app/services/name-formatting.service';

@Component({
  selector: '',
  templateUrl: './employee-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class EmployeeContextMenuComponent {
  // @Input()
  employeeDto: EmployeeV2Dto;

  // @Input()
  employerDto: EmployerDto; // should be an enterprise Dto
  // implementId: number;

  hasGrantToWriteEmployee: boolean;

  beaconsList: ExaBeaconV2Dto[] = [];
  temp_beaconsList: ExaBeaconV2Dto[] = [];

  constructor(
    private navParams: NavParams,
    private router: Router,
    private popoverController: PopoverController,
    private alertService: AlertService,
    private toastController: ToastController,
    private translate: TranslateService,
    private beaconRestService: ExaBeaconRestService,
    private modalCtrl: ModalController,
    private employeeService: EmployeeService
  ) {
    this.employeeDto = this.navParams.data.employeeDto;
    this.employerDto = this.navParams.data.employerDto;
    this.hasGrantToWriteEmployee = this.navParams.data.hasGrantToWriteEmployee;

    console.log(this.employeeDto);

    this.beaconRestService.getBeaconsUsingPOST(this.employerDto.username).forEach((beacon) => {
      beacon.content.forEach((el) => {
        if (el.type === BeaconTypeEnum.B_DRIVER) {
          this.beaconsList.push(el);
          this.temp_beaconsList.push(el);
        }
      });
    });
  }

  // =========================== BUTTONS ====================================

  onSearch(e) {
    const query = e.detail.value.toLowerCase();
    this.beaconsList = this.temp_beaconsList.filter((beacon) => beacon.serial?.toLowerCase().indexOf(query) > -1);
  }

  selectBeacon(beacon: string) {
    this.beaconRestService.assignToEmployeeUsingPOST(this.employeeDto.employeeId, beacon).subscribe((data) => {
    this.modalCtrl.dismiss();
    this.beaconsList = this.temp_beaconsList;
    this.toastController
      .create({
        message: this.translate.instant('BEACON.ASSIGN.SUCCESS'),
        duration: 5000,
      })
      .then((toast) => {
        toast.present();
      });
      this.DismissClick();
    });
 
  }

    public getEmployeeName(employeeDto?: EmployeeV2Dto | EmployeeIdDto): string {
    return NameFormattingService.getEmployeeName(employeeDto);
  }

  onClickEdit() {
    let this_employee_id = this.employeeDto.employeeId;
    this.router.navigateByUrl('/employees/add-edit-employee/' + this_employee_id);
    this.DismissClick();
  }

  onClickDelete() {
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('EMPLOYEE.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          let employeeId = this.employeeDto.employeeId;

          this.employeeService.deleteEmployee(employeeId).then(() => {
            // egal was passiert das popover schliesst sich
            this.DismissClick();
          });
        }
      });
  }

  onClickActivate() {
    // set active property of user
    // this.employeeDto.employeeState = EmployeeStateEnum.ACTIVE;
    let username = this.employeeDto.username;
    let enterpriseUsername = this.employerDto.username;
    this.employeeDto.active = true;

    this.employeeService.editEmployee(username, enterpriseUsername, this.employeeDto).then(
      (ret) => {},
      (err) => {}
    );
    this.DismissClick();
  }

  onClickDeactivate() {
    // set active property of user
    // this.employeeDto.employeeState = EmployeeStateEnum.ACTIVE;
    let username = this.employeeDto.username;
    let enterpriseUsername = this.employerDto.username;
    this.employeeDto.active = false;

    this.employeeService.editEmployee(username, enterpriseUsername, this.employeeDto).then(
      (ret) => {},
      (err) => {}
    );
    this.DismissClick();
  }

  // =========================== MISC ====================================

  async DismissClick() {
    // dismiss the popover
    // const employeesList = [];
    const data = 'some data'; 
    await this.popoverController.dismiss(data);
  }
}
